import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SMFT.css';
import Toast from '../../Toast';
import logoImage from '../../../resources/1000028180.jpeg';
import { FiMenu } from 'react-icons/fi';

export default function EmotionalControl() {
  const questions = [
    'I can control my emotions during competition.',
    'I stay calm and composed when things don\'t go as planned.',
    'I manage my emotional responses effectively during training and competition.',
  ];

  const [responses, setResponses] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('warning');
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Load saved responses when component mounts 
  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('smft30') || '{}');
    if (savedData.emotional_control && Array.isArray(savedData.emotional_control)) {
      const savedResponses = {};
      savedData.emotional_control.forEach((value, index) => {
        savedResponses[index] = value;
      });
      setResponses(savedResponses);
    }
  }, []);

  const handleSelect = (index, value) => {
    const updated = { ...responses, [index]: value };
    setResponses(updated);

    const emotionalArray = Object.keys(updated)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => updated[key]);

    const existing = JSON.parse(localStorage.getItem('smft30') || '{}');
    localStorage.setItem('smft30', JSON.stringify({
      ...existing,
      emotional_control: emotionalArray,
    }));
  };

  const handleNext = () => {
    if (questions.some((_, idx) => !responses[idx])) {
      setToastMessage('Please answer all questions before proceeding.');
      setToastType('warning');
      setShowToast(true);
      return;
    }
    navigate('/Leadership');
  };

  const currentSection = 7;
  const totalSections = 22;
  const answerLabels = [
    'Never',
    'Rarely',
    'Often',
    'Always'
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
      fontFamily: 'Poppins, sans-serif',
    }}>
      <header className="dashboard-header" style={{position: 'static'}}>
        <div className="header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div className="header-logo-container" style={{ display: 'flex', alignItems: 'center' }}>
                                  <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo" style={{ whiteSpace: window.innerWidth <= 600 ? 'nowrap' : undefined, fontSize: window.innerWidth <= 600 ? 22 : undefined }}>Power Mind Metrics</h1>
          </div>
          {window.innerWidth > 600 ? (
            <nav className="header-nav desktop-nav">
              <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
              <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
            </nav>
          ) : (
            <div className="mobile-nav-menu">
              <button className="hamburger-btn" onClick={() => setMobileMenuOpen(v => !v)} style={{ background: 'none', border: 'none', padding: 0, marginLeft: 0, marginRight: 8 }}>
                <FiMenu size={28} />
              </button>
              {mobileMenuOpen && (
                <div className="mobile-nav-dropdown" style={{ position: 'absolute', top: 60, right: 10, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.12)', zIndex: 1000, padding: 8 }}>
                  <button className="nav-link" style={{ display: 'block', width: '100%', textAlign: 'left', padding: 8 }} onClick={() => { setMobileMenuOpen(false); navigate('/profile'); }}>Profile</button>
                  <button className="nav-link" style={{ display: 'block', width: '100%', textAlign: 'left', padding: 8 }} onClick={() => { setMobileMenuOpen(false); navigate('/logout'); }}>Logout</button>
                </div>
              )}
            </div>
          )}
        </div>
      </header>
      <div style={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 64,
      }}>
        <div
          style={
            window.innerWidth > 600
              ? {
                  background: '#fff',
                  borderRadius: 8,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: 1028,
                  height: 670,
                  padding: 24,
                  opacity: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  marginBottom: 50,
                }
              : {
                  background: '#fff',
                  borderRadius: '1.2rem',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: '100vw',
                  maxWidth: '98vw',
                  minWidth: 0,
                  padding: '1.2rem 0.7rem 1.5rem 0.7rem',
                  boxSizing: 'border-box',
                  margin: 0,
                  marginBottom: '110px', // increased to prevent footer overlap
                }
          }
        >
          <h1 style={{fontWeight: 700, fontSize: 32, color: '#444', marginBottom: 16, textAlign: 'center'}}>SMFT-30 Assessment</h1>
          <div style={{width: '100%', marginBottom: 24}}>
            <div style={{fontWeight: 500, fontSize: 20, marginBottom: 8}}>Step 7 of 22: <span style={{fontWeight: 600}}>Emotional Control</span></div>
            <div style={{display: 'flex', flexDirection: 'row', gap: 16, width: '100%', marginTop: 8, marginBottom: 8}}>
              {[...Array(totalSections)].map((_, i) => (
                <div
                  key={i}
                  style={{
                    flex: 1,
                    height: 10,
                    borderRadius: 6,
                    background: currentSection > i ? '#2AA7A1' : '#e0e0e0',
                    transition: 'background 0.3s',
                  }}
                />
              ))}
            </div>
          </div>
          {questions.map((question, index) => (
            <div key={index} style={{marginBottom: 24, width: '100%'}}>
              <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8, textAlign: 'left'}}>{question}</div>
              {window.innerWidth > 600 ? (
                <>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4, width: '100%'}}>
                    {answerLabels.map((label, i) => (
                      <span key={i} style={{fontSize: 13, color: '#444', width: 120, textAlign: 'center'}}>{label}</span>
                    ))}
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                    {answerLabels.map((label, i) => (
                      <label key={i} style={{width: 120, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                        <input
                          type="radio"
                          name={`q${index}`}
                          value={i+1}
                          checked={responses[index] === i+1}
                          onChange={() => handleSelect(index, i+1)}
                          style={{width: 18, height: 18, accentColor: ' rgb(15, 148, 150)'}}
                        />
                      </label>
                    ))}
                  </div>
                </>
              ) : (
                (() => {
                  // Always render pairs of two for mobile, for 4 options
                  const pairs = [[1,2],[3,4]];
                  return pairs.map((pair, rowIdx) => (
                    <div key={rowIdx} className="mtt20-options-pair-row">
                      {pair.map((value) => (
                        <label key={value} className="mtt20-option-label">
                          <input
                            type="radio"
                            name={`q${index}`}
                            value={value}
                            checked={responses[index] === value}
                            onChange={() => handleSelect(index, value)}
                            className="mtt20-radio"
                          />
                          <span className="mtt20-option-label-text">{answerLabels[value-1]}</span>
                        </label>
                      ))}
                    </div>
                  ));
                })()
              )}
            </div>
          ))}
          <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 24, marginBottom: window.innerWidth <= 600 ? 32 : 0}}>
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              style={{
                border: '2px solid #2aa7a1',
                background: '#fff',
                color: '#2aa7a1',
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 16,
                fontFamily: 'Poppins, sans-serif',
                cursor: 'pointer',
                transition: 'background 0.2s, color 0.2s',
                height: 40,
                width: 107,
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleNext}
              style={{
                border: 'none',
                background: '#2aa7a1',
                color: '#fff',
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 16,
                fontFamily: 'Poppins, sans-serif',
                cursor: 'pointer',
                transition: 'background 0.2s',
                height: 40,
                width: 170,
              }}
            >
              Next Section
            </button>
          </div>
          {showToast && (
            <Toast
              message={toastMessage}
              type={toastType}
              onClose={() => setShowToast(false)}
            />
          )}
        </div>
      </div>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
}
